import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

export const BudgetQuoteBox: any = styled(Box)`
    width: 100%;
    display: flex;
    flex: 1 0 1;
    flex-direction: column;
    padding: 30px 0 60px 0;

    .BQSEdit {
        .MuiInputLabel-root,
        label {
            font-family: "Nexa Light";
        }
        min-width: 300px;
    }

    .form-wrapper {
        padding: 0 15px;
        width: 100%;
        max-width: 1140px;
        display: flex;
        flex: 1 0 1;
        flex-direction: column;
        margin: 0 auto;
    }

    .user-consent {
        display: flex;
        flex: 1 0 1;
        flex-direction: row;
        padding-top: 15px;
    }

    .inerror {
        background-color: rgba(255, 223, 224, 0.25);
        margin-bottom: 6px !important;
        border-top: 1px solid #c89797;
        border-bottom: 1px solid #c89797;
        padding-bottom: 6px;
        padding-top: 8px;
    }

    /* can't see how to do this with overides */
    .MuiFormHelperText-root {
        &.Mui-error {
            color: #790000;
            font-weight: 700;
            letter-spacing: normal;
        }
    }

    .submitRow {
        min-width: 100%;
        display: flex;
        flex: 1 0 0;
        flex-direction: row;
        justify-content: flex-end;

        .BQSButton {
            max-width: 52px;
        }
    }
`;
